export default function Configure($stateProvider) {
    $stateProvider.state('mesures', {
        parent: 'common',
        url: '/mesures',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.ENVIRONNEMENT" | translate }}'
        }
    });

    $stateProvider.state('mesures.list', {
        url: '/list',
        template: '<mesures></mesures>',
        rights: { domain: 'mesures', right: 'read' },
        ncyBreadcrumb: {
            parent: 'mesures',
            label: '{{ "MESURES.BREADCRUMBS.MESURES_LIST" | translate}}'
        },
        navigation: {
            menu: 'environnement_theme_mes',
            translate: 'MESURES.BREADCRUMBS.MESURES_LIST',
            order: 5
        },
        search: 'MESURES.BREADCRUMBS.MESURES_LIST'
    });

    $stateProvider.state('mesures.list.detail', {
        url: '/{id}',
        template: '<mesure-detail></mesure-detail>',
        rights: { domain: 'mesures', right: 'read' },
        ncyBreadcrumb: {
            parent: 'mesures.list',
            label: '{{ "MESURES.BREADCRUMBS.MESURE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('mesures.new', {
        url: '/new',
        template: '<mesure-form></mesure-form>',
        rights: { domain: 'mesures', right: 'create' },
        ncyBreadcrumb: {
            parent: 'mesures.list',
            label: '{{ "MESURES.BREADCRUMBS.MESURE_NEW" | translate}}'
        },
        search: 'MESURES.BREADCRUMBS.MESURE_NEW'
    });

    $stateProvider.state('mesures.edit', {
        url: '/{id}/edit',
        template: '<mesure-form></mesure-form>',
        rights: { domain: 'mesures', right: 'update' },
        ncyBreadcrumb: {
            parent: 'mesures.list',
            label: '{{ "MESURES.BREADCRUMBS.MESURE_EDIT" | translate }}'
        }
    });

    $stateProvider.state('mesures.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: { parentState: 'mesures.new' },
        ncyBreadcrumb: {
            parent: 'mesures.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });

    $stateProvider.state('mesures.duplicate', {
        url: '/{id}/duplicate',
        template: '<mesure-form></mesure-form>',
        rights: { domain: 'mesures', right: 'create' },
        ncyBreadcrumb: {
            parent: 'mesures.list',
            label: '{{ "MESURES.BREADCRUMBS.MESURE_NEW" | translate}}'
        },
        params: {
            duplicate: true
        }
    });
}

Configure.$inject = ['$stateProvider'];
